import contratos from './flights/contratos'
import contratosCar from './cars/contratos'
import contratosHotel from './hotels/contratos'

export default [...contratos, ...contratosCar, ...contratosHotel]
